import React from "react";
import { Grid } from "@material-ui/core";

import {
  DateInput,
  Input,
  TextArea,
  withNamespace,
} from "components/Form/FormikControls";

interface CommonPaymentFieldsProps {
  namespace?: string;
}

export function CommonPaymentFields(
  props: CommonPaymentFieldsProps,
): React.JSX.Element {
  const { namespace: ns = "" } = props;

  return (
    <>
      <Grid item sm={6}>
        <Input label="Reference" name={withNamespace(ns, "paymentRef")} />
      </Grid>
      <Grid item sm={6}>
        <DateInput
          label="Payment Date"
          name={withNamespace(ns, "paymentDate")}
        />
      </Grid>
      <Grid item sm={12}>
        <TextArea label="Notes" name={withNamespace(ns, "notes")} />
      </Grid>
    </>
  );
}
